module.exports = __webpack_public_path__ + "static/media/flutter2.be2874df.png";